export const MAIN_CLASS_NAME = 'error-layout';
export const LOGO_CONTAINER_CLASS_NAME = `${MAIN_CLASS_NAME}__logo-container`;
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const FRAME_CLASS_NAME = `${CONTENT_CLASS_NAME}__frame`;
export const TITLE_CLASS_NAME = `${FRAME_CLASS_NAME}__title`;
export const DESCRIPTION_CLASS_NAME = `${FRAME_CLASS_NAME}__description`;

export const CORTEX_LOGO_HEIGHT = 80;
export const CORTEX_LOGO_WIDTH = 344;
